import styled from 'styled-components';
import { Cell } from '@dexma/ui-components';

type CellProps = {
    $fontColor?: string | null;
    $backgroundColor: string | null;
    align: string | null;
    $fontWeight?: number | null;
    $flexAlign: string;
    xs?: number | null;
    sm?: number | null;
    md?: number | null;
    lg?: number | null;
    $xsOffset?: number | null;
    $smOffset?: number | null;
    $mdOffset?: number | null;
    $lgOffset?: number | null;
};

type StyledTableWrapperProps = {
    $hideOverflowScrollbar?: boolean;
};

export const StyledTitleWrapper = styled.div`
    margin-bottom: 16px;
    margin-top: 8px;
    padding-left: 20px;
    margin-right: 12px;
    padding-bottom: 4px;
    width: 100%;
    font-weight: 700;
`;

export const StyledTableWrapper = styled.div<StyledTableWrapperProps>`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 16px);
    > [data-testid='table'] {
        overflow: ${({ $hideOverflowScrollbar }) => ($hideOverflowScrollbar ? 'hidden' : 'auto')};
        width: 100%;
    }

    th.ant-table-cell.hidden-sort-arrrows.ant-table-cell-fix-left.ant-table-cell-fix-left-last.ant-table-column-has-sorters {
        cursor: default;
    }

    th.ant-table-cell.hidden-sort-arrrows.ant-table-cell-fix-left.ant-table-cell-fix-left-last.ant-table-column-has-sorters
        > div
        > span.ant-table-column-sorter.ant-table-column-sorter-full {
        visibility: hidden;
    }
`;

export const StyledTableCell = styled(Cell)<CellProps>`
    color: ${(props) => props.$fontColor};
    background-color: ${(props) => props.$backgroundColor};
    text-align: ${(props) => props.align};
    font-weight: ${(props) => props.$fontWeight};
    display: flex;
    overflow: hidden;
    justify-content: ${(props) => props.$flexAlign};
`;
